<template>
	<right-panel :datas="connects" @onClose="onClose" ref="right-panel">
		<div slot="header">
			<translate>Join WorkGroup</translate>
		</div>
		<div slot="content" class="wrapper-padding" style="height: 100%">
			<el-form ref="workgroupForm" :rules="rules" :model="workgroupForm" class="workgroupForm">
				<!-- <el-form-item :label="attrText.type" >
					<el-select v-model="workgroupForm.type">
						<el-option :label="attrText.administrator" value="1"></el-option>
						<el-option :label="attrText.ordinary" value="0"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item prop="project_ids">
					<el-select ref="workgroups" v-model="workgroupForm.project_ids" multiple filterable :placeholder="attrText.inputName" :loading="loading" @change="onChangeSelect">
						<el-option class="select-item" v-for="item in workgroupForm.list" :key="item.id" :label="item.name" :value="item.id"> {{ item.name }}<br />{{ item.account }} </el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="detail-btn">
			<el-button type="primary" :disabled="!workgroupForm.project_ids.length" @click="onSubmit()">
				<translate>Submit</translate>
			</el-button>
			<el-button @click="$refs['right-panel'].onClose()">
				<translate>Cancel</translate>
			</el-button>
		</div>
	</right-panel>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import { Utils } from '../../../config'
import RightPanel from '../../common/right-panel'
import Vue from 'vue'

// 资源名称提示
Vue.component('allMember', {
	functional: true,
	render: function (h, ctx) {
		let item = ctx.props.item
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item.name]), h('div', {}, [item.account])])
	},
	props: {
		item: { type: Object, required: true },
	},
})
export default {
	name: 'GroupAddWorkgroup',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			loading: false,
			workgroupForm: {
				list: [],
				type: '0',
				project_ids: [],
				memberDis: false,
			},
			memberName: false,
			rules: {
				value: [{ required: true, message: this.$gettext('Please input workgroup name'), trigger: 'change' }],
			},
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	created() {
		this.getAllWorkgroup()
	},
	methods: {
		// 提取翻译文本
		getTranslateText() {
			return {
				member: this.$gettext('Member'),
				type: this.$gettext('Type'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				inputName: this.$gettext('Please input workgroup name search'),
				inputSearch: this.$gettext('Search'),
			}
		},
		// 获取所有工作组
		getAllWorkgroup() {
			let params = {
				group_id: this.$route.params.id,
				page_size: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP, params).then((res) => {
				this.workgroupForm.list = res.objects
			})
		},

		// 选中
		onChangeSelect(val) {
			console.log('select-val', val)
			this.$refs.workgroups.query = ''
		},

		onSubmit() {
			this.$refs['workgroupForm'].validate((valid) => {
				if (valid) {
					let params = {
						id: this.$route.params.id,
						project_id: this.workgroupForm.project_ids,
						// role: Number(this.workgroupForm.type)
					}
					if (!this.workgroupForm.project_ids) {
						this.$notify({
							type: 'error',
							message: this.$gettext('Workgroup is found'),
						})
					} else {
						this.$store
							.dispatch(STORE_CONST.WORKGROUP.ADD_GROUP_WORKGROUP, params)
							.then((res) => {
								this.$notify({
									type: 'success',
									message: this.$gettext('Add success'),
								})
								this.$emit('callback')
								this.$refs['right-panel'].onClose()
							})
							.catch((err) => {
								this.$emit('callback')
								this.$refs['right-panel'].onClose()
							})
					}
				} else {
					return false
				}
			})
		},
		// 关闭创建集群
		onClose() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
.workgroupForm {
	.auto-complete {
		width: 100%;
	}
	.el-input__inner {
		border: none;
	}
	.el-select__input {
		width: 160px !important;
	}
	.el-select .el-tag {
		background-color: #e4e8f1;
		border-color: #fff;
		color: #48576a;
		i.el-icon-close:hover {
			background-color: #48576a;
		}
	}
	.el-tag--primary.is-hit {
		border-color: #48576a;
	}
}
.select-item {
	height: auto;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
	top: 10px;
}
</style>



// WEBPACK FOOTER //
// group-add-workgroup.vue?71707df0